
/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}



// WEBPACK FOOTER //
// ./src/util/validate.js